// export const serverUrl = 'http://api.flightdrop.co/';
export const serverUrl = "https://flightdrop-backend-jack.herokuapp.com/";

export const botMessages = [
  [
    {
      type: "bot",
      message: "What is your date of birth?"
    }
  ],
  [
    {
      type: "bot",
      message: "What is your nationality?"
    }
  ],

  [
    {
      type: "bot",
      message: "Finally I need your mobile to verify you aren't a robot."
    }
  ],
  [
    {
      type: "bot",
      message: "Please confirm the sms code received."
    }
  ],
  [
    {
      type: "bot",
      mark: 1,
      message:
        "Now I've logged your offer information and created your tenancy group, let's do your profile test, to unlock insider access to properties, perks and packages."
    },
    {
      type: "bot",
      message: "Would you classify yourself as creative or functional person?"
    }
  ],
  [
    {
      type: "bot",
      message: "What do you prefer doing in your spare time?"
    }
  ],
  [
    {
      type: "bot",
      message: "What is your favourite pet?"
    }
  ],
  [
    {
      type: "bot",
      message: "By Saving £400 a month, how will you spend this?"
    }
  ],
  [
    {
      type: "bot",
      message: "What is your current employment status?"
    }
  ],
  [
    {
      type: "bot",
      mark: 2,
      message:
        "Great, Now I know more about you, I can tailor the perks I give you. Next, I'll verify your credit & rental history."
    },
    {
      type: "bot",
      message: "Status of your current address?"
    }
  ],
  [
    {
      type: "bot",
      message: "Your current postcode?"
    }
  ],
  [
    {
      type: "bot",
      message: "Choose your location."
    }
  ],
  [
    {
      type: "bot",
      message: "Since when have you been living at your current address?"
    }
  ],
  [
    {
      type: "bot",
      mark: 3,
      message:
        "I've now verified your core information and can provide you with monthly credit score updates for free!"
    },

    {
      type: "bot",
      message: "Gross annual salary?"
    }
  ],
  [
    {
      type: "bot",
      message: "Your national insurance number?"
    }
  ],
  [
    {
      type: "bot",
      message: "Do you have any pending/historic adverse credit?"
    }
  ],
  [
    {
      type: "bot",
      message: "Do you have any CCJ's or Court Decrees?"
    }
  ],
  [
    {
      type: "bot",
      message: "Do you have ever been declared bankrupt or any IVA's etc?"
    }
  ]
];

export const userMessages = [
  {
    type: "user",
    inputType: "input",
    key: "username",
    placeholder: "First Name Last Name",
    isNext: true
  },
  {
    type: "user",
    inputType: "date",
    placeholder: "DD/MM/YYYY",
    key: "DOB"
  },
  {
    type: "user",
    inputType: "nation",
    placeholder: "",
    key: "nation"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "",
    key: "phone"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "6-digits",
    key: "sms"
  },

  {
    type: "user",
    inputType: "toggleButton",
    options: [
      {
        text: "Creative",
        value: "Creative"
      },
      {
        text: "Functional",
        value: "Functional"
      }
    ],
    key: "personalType"
  },
  {
    type: "user",
    inputType: "toggleButton",
    options: [
      {
        text: "Reading & Learning",
        value: "Reading & Learning"
      },
      {
        text: "Health & Exercise",
        value: "Health & Exercise"
      },
      {
        text: "Music & Arts",
        value: "Music & Arts"
      },
      {
        text: "Exploring & Eating",
        value: "Exploring & Eating"
      }
    ],
    key: "spareType"
  },
  {
    type: "user",
    inputType: "toggleButton",
    options: [
      {
        text: "Cat",
        value: "Cat"
      },
      {
        text: "Dog",
        value: "Dog"
      },
      {
        text: "Fish",
        value: "Fish"
      },
      {
        text: "I don't like pets or have one",
        value: "Nothing"
      }
    ],
    key: "animalType"
  },
  {
    type: "user",
    inputType: "toggleButton",
    options: [
      {
        text: "Socialising",
        value: "Social"
      },
      {
        text: "Travel",
        value: "Travel"
      },
      {
        text: "Fashion",
        value: "Fashion"
      },
      {
        text: "Health",
        value: "Health"
      }
    ],
    key: "socialType"
  },
  {
    type: "user",
    inputType: "toggleButton",
    options: [
      {
        text: "Employed",
        value: "Employed"
      },
      {
        text: "Self Employed",
        value: "Self employed"
      },
      {
        text: "Unemployed",
        value: "Unemployed"
      }
    ],
    key: "employmentType"
  },
  {
    type: "user",
    inputType: "toggleButton",
    options: [
      {
        text: "Owned",
        value: "Owned"
      },
      {
        text: "Rented",
        value: "Rented"
      },
      {
        text: "Other",
        value: "Other"
      }
    ],
    key: "addressType"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Postcode",
    key: "postcode"
  },
  {
    type: "user",
    inputType: "address",
    key: "current_address"
  },
  {
    type: "user",
    inputType: "date",
    key: "current_address_startdate"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "0",
    isNext: true,
    key: "salary"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Insurance number",
    key: "insurance_number"
  },
  {
    type: "user",
    inputType: "yes/no",
    key: "ph_credit"
  },
  {
    type: "user",
    inputType: "yes/no",
    key: "ccj"
  },
  {
    type: "user",
    inputType: "yes/no",
    key: "bankrupt"
  }
];
export const employed_botMessages = [
  [
    {
      type: "bot",
      mark: 4,
      message:
        "You are on the last stage. Let me know your employment info. This helps me prove your affordability and professional profile."
    },
    {
      type: "bot",
      message: "What is the name of the company you work for?"
    }
  ],
  [
    {
      type: "bot",
      message: "Please provide your employer website?"
    }
  ],
  [
    {
      type: "bot",
      message: "What is your position/title?"
    }
  ],

  [
    {
      type: "bot",
      message: "What is your payroll number?"
    }
  ],
  [
    {
      type: "bot",
      message: "Your start date?"
    }
  ],
  [
    {
      type: "bot",
      message:
        "Please provide me the name of someone at your work, with whom we can verify your employment?"
    }
  ],
  [
    {
      type: "bot",
      message:
        "Is your current position going to change in the near future yes/no?"
    }
  ],
  [
    {
      type: "bot",
      message:
        "Please upload a copy of your bank statement or take a photo. Needs to be within the last 3 months."
    }
  ],
  [
    {
      type: "bot",
      message:
        "Declaration that the information you have supplied is your own, true and accurate."
    }
  ],
  [
    {
      type: "bot",
      mark: 5,
      message:
        "You are verified and eligible to be a Bolt Member. Register an account now to join."
    },
    {
      type: "bot",
      message: "What is your email address?"
    }
  ],
  [
    {
      type: "bot",
      message: "Please set your password."
    },
    {
      type: "bot",
      message:
        "Length should be greater than 8 characters containing atleast 1 lowercase, 1 uppercase and 1 digit."
    }
  ],
  [
    {
      type: "bot",
      end: true,
      message:
        "Congratulations, you are now a Bolt member. Download your concierge app <a href='#'>here</a>"
    }
  ]
];
export const self_employed_botMessages = [
  [
    {
      type: "bot",
      mark: 4,
      message:
        "You are on the last stage. Let me know your employment info. This helps me prove your affordability and professional profile."
    },
    {
      type: "bot",
      message: "Name of accountant?"
    }
  ],
  [
    {
      type: "bot",
      message: "Email address of accountant?"
    }
  ],
  [
    {
      type: "bot",
      message: "Phone number of accountant?"
    }
  ],
  [
    {
      type: "bot",
      message: "Upload your most recent self-assessment tax return documents."
    }
  ],
  [
    {
      type: "bot",
      message:
        "Upload a signed audit of personal accounts from your accountant."
    }
  ],
  [
    {
      type: "bot",
      message:
        "Declaration that the information you have supplied is your own, true and accurate."
    }
  ],
  [
    {
      type: "bot",
      mark: 5,
      message:
        "You are verified and eligible to be a Bolt Member. Register an account now to join."
    },
    {
      type: "bot",
      message: "What is your email address?"
    }
  ],
  [
    {
      type: "bot",
      message: "Please set your password."
    },
    {
      type: "bot",
      message:
        "Length should be greater than 8 characters containing atleast 1 lowercase, 1 uppercase and 1 digit."
    }
  ],
  [
    {
      type: "bot",
      end: true,
      message:
        "Congratulations, you are now a Bolt member. Download your concierge app <a href='#'>here</a>"
    }
  ]
];
export const employed_userMessages = [
  {
    type: "user",
    inputType: "input",
    placeholder: "Name",
    key: "company_name"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "",
    key: "company_site"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "",
    key: "position/title"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Number",
    key: "payroll_number"
  },
  {
    type: "user",
    inputType: "date",
    placeholder: "dd/mm/yyyy",
    key: "business_startdate"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "First Name Last Name",
    key: "partner_username"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Email",
    key: "partner_email"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "",
    key: "partner_phone"
  },
  {
    type: "user",
    inputType: "yes/no",
    key: "position_future_change"
  },
  {
    type: "user",
    inputType: "upload",
    placeholder: "",
    key: "bankstatement"
  },
  {
    type: "user",
    inputType: "static",
    message: "Accept & Completed"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Email",
    key: "email"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Password",
    key: "password"
  },
  {
    type: "user",
    inputType: "static",
    message: "Finish & Go to Deals",
    finish: true
  }
];
export const self_employed_userMessages = [
  {
    type: "user",
    inputType: "input",
    placeholder: "First Name Last Name",
    key: "accountant_username"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Email",
    key: "accountant_email"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "",
    key: "accountant_phone"
  },
  {
    type: "user",
    inputType: "upload",
    placeholder: "",
    key: "Self-assessment"
  },
  {
    type: "user",
    inputType: "upload",
    placeholder: "",
    key: "Signed-audit"
  },
  {
    type: "user",
    inputType: "static",
    message: "Accept & Completed"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Email",
    key: "email"
  },
  {
    type: "user",
    inputType: "input",
    placeholder: "Password",
    key: "password"
  },
  {
    type: "user",
    inputType: "static",
    message: "Finish & Go to Deals",
    finish: true
  }
];



// WEBPACK FOOTER //
// ./src/Constants/messages.js